document.querySelectorAll('.hero__gallery').forEach((gallery) => {
    const swiperEl = gallery.querySelector('.hero__gallery-swiper');
    if (!swiperEl) return;

    new Swiper(swiperEl, {
        direction: 'vertical',
        loop: true,
        loopAdditionalSlides: 6,
        slidesPerView: 'auto',
        spaceBetween: 130,
        speed: 10000,
        allowTouchMove: false,
        autoplay: {
            delay: 1,
            disableOnInteraction: true,
        },
    });
});
